<div class="h-100 w-100 spinnerOverlay" [ngClass]="{'spinnerOverlayIsLoading': isLoading}">
	<div class="d-flex justify-content-center align-items-center h-100">
		<div class="loading-house">
			<img class="b letter" src="assets/img/logo_letters/b.png" alt="b">
      <img class="u letter" src="assets/img/logo_letters/u.png" alt="u">
      <img class="i letter" src="assets/img/logo_letters/i.png" alt="1">
      <img class="l letter" src="assets/img/logo_letters/l.png" alt="l">
      <img class="t letter" src="assets/img/logo_letters/t.png" alt="t">
      <img class="g letter" src="assets/img/logo_letters/g.png" alt="g">
      <img class="e letter" src="assets/img/logo_letters/e.png" alt="e">
      <img class="n letter" src="assets/img/logo_letters/n.png" alt="n">
      <img class="i2 letter" src="assets/img/logo_letters/i2.png" alt="i2">
      <img class="x letter" src="assets/img/logo_letters/x.png" alt="x">
		</div>
	</div>
</div>
